import { findOverflowParent } from './findOverflowParent';
import { intersectRects } from './intersectRects';
import { getWindowRect } from './getWindowRect';
export function getViewportRect(elem, intersectElems) {
  const windowRect = getWindowRect();
  const overflowParent = findOverflowParent(elem);
  if (!overflowParent) {
    return windowRect;
  }
  let result = intersectRects(windowRect, overflowParent.getBoundingClientRect());

  // Если элементы указаны, то учитывает Rect каждого из них при пересечении.
  intersectElems == null || intersectElems.forEach(item => {
    result = intersectRects(result, item.getBoundingClientRect());
  });
  return result;
}